module.exports = __webpack_public_path__ + "static/media/logo.358fb4cd.svg";